import { UserEnquiryLog, UserEnquiryLogInput } from "../models/UserEnquiryLog"
import client from './apolloClient';
import { CREATE_USER_ENQUIRY, DELETE_USER_ENQUIRY, UPDATE_ENQUIRY_STATUS } from './mutation';




export const createNewEnquiry = async (newEnquiryLog: UserEnquiryLogInput): Promise<UserEnquiryLog> => {
    //  console.log("new newEnquiryLog = "+JSON.stringify(newEnquiryLog))
    try {
        const { data } = await client.mutate({
            mutation: CREATE_USER_ENQUIRY,
            variables: { newEnquiryLog },

        });
        return data?.createUserEnquiryLog;
    } catch (error) {
        console.log('Error fetching create new newEnquiryLog:', error);
        return { _id: "", name: "", phone: "", enquiryDate: '', userType: '', from: '', to: '', bookingDate: '', distance: 0, returnRide: false, status: '' };;
    }
}


export const deleteEnquiryById = async (id: string): Promise<Boolean> => {
    try {
        const { data } = await client.mutate({
            mutation: DELETE_USER_ENQUIRY,
            variables: { id },
            // context: {
            //     headers: {
            //         Authorization: AppContext.loggedAuthToken ? `Bearer ${AppContext.loggedAuthToken}` : '',
            //     },
            // }
        });
        return data?.deleteEnquiryById;
    } catch (error) {
        console.log('Error fetching deleteEnquiryById:', error);
        return false;
    }
}
export const updateEnquiryStatus = async (id: string, status: string): Promise<Boolean> => {
    try {
        const { data } = await client.mutate({
            mutation: UPDATE_ENQUIRY_STATUS,
            variables: { id, status },
            // context: {
            //     headers: {
            //         Authorization: AppContext.loggedAuthToken ? `Bearer ${AppContext.loggedAuthToken}` : '',
            //     },
            // }
        });
        return data?.updateEnquiryStatus;
    } catch (error) {
        console.log('Error fetching updateEnquiryStatus:', error);
        return false;
    }
}
